if ( ! customElements.get('cart-document-type') ) {
  customElements.define(
    'cart-document-type',
    class CartDocumentType extends HTMLElement {

      connectedCallback() {
        this.drawer = this.closest('[data-js-site-cart-sidebar]');
        if ( ! this.drawer ) return;

        this.form = this.querySelector('form');
        this.cedula = this.querySelector('[data-document-cedula]');
        this.rut = this.querySelector('[data-document-rut]');
        this.razon = this.querySelector('[data-document-razon]');
        this.empresa = this.querySelector('[data-document-empresa]');
        this.billingMenu = this.querySelector('.billing-menu');

        this.onInput = event => {
          if ( event.target === this.cedula || event.target === this.rut ) {
            const digitos = event.target === this.cedula ? 8 : 12;
            event.target.value = this.formatearDocumento(event.target.value, digitos);
          }
          this.verificarCampos();
        };

        this.onChange = event => {
          if ( event.target.matches('.document-type-selector') && this.contains(event.target) ) {
            this.cambiarDocumento();
          }
          this.verificarCampos();
        };

        this.onSubmit = event => {
          const cartForm = this.drawer.querySelector('cart-form form');
          if ( event.target !== this.form && event.target !== cartForm ) return;
          if ( event.submitter && event.submitter.name !== 'checkout' ) return;

          if ( ! this.verificarCampos() ) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.form.reportValidity();
            const terms = this.drawer.querySelector('#AgreeToTos');
            if ( terms && ! terms.checked ) terms.reportValidity();
            return;
          }

          // Los atributos se envían junto con la solicitud de checkout.
          if ( event.target === cartForm ) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.form.requestSubmit();
          }
        };

        this.addEventListener('input', this.onInput);
        this.drawer.addEventListener('change', this.onChange);
        this.drawer.addEventListener('submit', this.onSubmit, true);

        // El tema reemplaza el subtotal y su botón al actualizar el carrito.
        this.observer = new MutationObserver(() => this.verificarCampos());
        this.observer.observe(this.drawer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });

        this.cambiarDocumento();
        this.verificarCampos();
      }

      disconnectedCallback() {
        if ( ! this.drawer ) return;
        this.observer.disconnect();
        this.removeEventListener('input', this.onInput);
        this.drawer.removeEventListener('change', this.onChange);
        this.drawer.removeEventListener('submit', this.onSubmit, true);

        if ( this.checkoutButton && this.checkoutButton.isConnected ) {
          this.checkoutButton.setAttribute('form', this.originalForm);
          const terms = this.drawer.querySelector('#AgreeToTos');
          this.checkoutButton.disabled = Boolean(terms && ! terms.checked);
        }
      }

      cambiarDocumento() {
        const factura = this.querySelector('.document-type-selector:checked').value === 'factura';
        this.billingMenu.hidden = ! factura;
        this.billingMenu.querySelectorAll('input').forEach(input => {
          input.required = factura;
          if ( ! factura ) input.value = '';
        });
      }

      formatearDocumento(valor, digitos) {
        const documento = String(valor).replace(/[^\d]/g, '').slice(0, digitos);
        if ( documento.length <= 1 ) return documento;
        return documento.slice(0, -1) + '-' + documento.slice(-1);
      }

      validarCedula(valor) {
        const documento = valor.replace(/[.\-\s]/g, '');
        if ( ! /^\d{7,8}$/.test(documento) ) return false;

        const coeficientes = [2, 9, 8, 7, 6, 3, 4, 1];
        const diferencia = coeficientes.length - documento.length;
        let suma = 0;
        for ( let i = 0; i < documento.length; i++ ) {
          suma += parseInt(documento[i], 10) * coeficientes[i + diferencia];
        }
        return suma % 10 === 0;
      }

      validarRUT_UY(valor) {
        const documento = valor.replace(/[.\-\s]/g, '');
        if ( ! documento ) return 'RUT es obligatorio para Factura';
        if ( ! /^\d{12}$/.test(documento) ) return 'RUT debe tener 12 dígitos';

        const coeficientes = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let suma = 0;
        for ( let i = 0; i < coeficientes.length; i++ ) {
          suma += parseInt(documento[i], 10) * coeficientes[i];
        }

        let digitoVerificador = 11 - (suma % 11);
        if ( digitoVerificador === 11 ) digitoVerificador = 0;
        if ( digitoVerificador === 10 || digitoVerificador !== parseInt(documento[11], 10) ) {
          return 'RUT Inválido (dígito verificador incorrecto)';
        }
        return '';
      }

      marcarCampo(input, mensaje) {
        input.setCustomValidity(mensaje);
        input.classList.toggle('invalido', mensaje !== '');
        input.setAttribute('aria-invalid', mensaje !== '' ? 'true' : 'false');
      }

      verificarCampos() {
        const factura = this.querySelector('.document-type-selector:checked').value === 'factura';
        const cedulaValida = this.validarCedula(this.cedula.value);
        this.marcarCampo(this.cedula, cedulaValida ? '' : (
          this.cedula.value.trim() ? 'Cédula inválida o incompleta' : 'Cédula es obligatoria'
        ));
        this.marcarCampo(this.rut, factura ? this.validarRUT_UY(this.rut.value) : '');
        this.marcarCampo(this.razon, factura && ! this.razon.value.trim() ? 'Razón Social es obligatoria' : '');
        this.marcarCampo(this.empresa, factura && ! this.empresa.value.trim() ? 'Nombre de empresa es obligatorio' : '');

        const terms = this.drawer.querySelector('#AgreeToTos');
        const valido = cedulaValida && this.rut.validity.valid && this.razon.validity.valid
          && this.empresa.validity.valid && (! terms || terms.checked);
        const button = this.drawer.querySelector('button[name="checkout"]');

        if ( button ) {
          if ( button !== this.checkoutButton ) {
            this.checkoutButton = button;
            const originalForm = button.getAttribute('form');
            this.originalForm = originalForm && originalForm !== this.form.id ? originalForm : 'cart';
          }
          if ( button.getAttribute('form') !== this.form.id ) button.setAttribute('form', this.form.id);
          if ( button.disabled !== ! valido ) button.disabled = ! valido;
        }

        return valido;
      }
    }
  );
}
